import type {FC, ReactElement} from 'react'

interface RenderIfProps {
  isTrue: boolean
  children: ReactElement
}

/** Lightweight conditional render without Redux or feature-module dependencies. */
export const RenderIf: FC<RenderIfProps> = ({children, isTrue}) =>
  isTrue ? children : null
